import { useEffect, useState } from "react";
// In production: import { GetProjects } from "../../services/ProjectService";
import { GetProjects } from "../../../../services/ProjectService";
// For dev/preview with mock data:
import { ProjectGrid } from "./components/ProjectGrid";
import { WorkTabs } from "./components/WorkTabs";

const TABS = [
	{
		id: "client_public",
		label: "Client Work (Public)",
		emoji: "💼",
		desc: "Professional deliverables — source is private but the product is live.",
	},
	{
		id: "client_confidential",
		label: "Client Work (Private)",
		emoji: "🔒",
		desc: "Projects under NDA. I can share what I worked on, but not the code.",
	},
	{
		id: "personal",
		label: "Personal",
		emoji: "⚡",
		desc: "Side projects & open-source work I built for fun or learning.",
	},
];

export const WorkSection = () => {
	const [activeTab, setActiveTab] = useState("client_public");
	const [projects, setProjects] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		// Switch to: GetProjects().then(...) for production
		// Mock version:
		// setProjects(MOCK_PROJECTS);
		// setLoading(false);

		GetProjects().then((data) => {
			setProjects(data);
			setLoading(false);
		});
	}, []);

	const filtered = projects.filter((p) => p.category === activeTab);
	const currentTab = TABS.find((t) => t.id === activeTab);

	return (
		<section
			id="work_section"
			className="relative z-[2] px-2 md:px-8 xl:px-0 pt-[60px] pb-[80px] lg:pt-[100px] lg:pb-[140px]">
			<div className="max-w-screen-xl mx-auto">
				{/* Section header */}
				<div className="mb-10 md:mb-14">
					<p className="font-mono text-xs tracking-[0.2em] uppercase text-[#888] dark:text-[#555] mb-3">
						Selected Work
					</p>
					<h2 className="font-poppins font-semibold text-3xl md:text-[40px] leading-none text-black dark:text-[#D8D8D8]">
						Projects
					</h2>
				</div>

				{/* Tabs */}
				<WorkTabs
					tabs={TABS}
					activeTab={activeTab}
					onTabChange={setActiveTab}
					counts={Object.fromEntries(
						TABS.map((t) => [
							t.id,
							projects.filter((p) => p.category === t.id).length,
						]),
					)}
				/>

				{/* Tab description */}
				<p className="mt-5 mb-8 text-sm text-[#888] dark:text-[#555] font-lato">
					{currentTab?.desc}
				</p>

				{/* Content */}
				<ProjectGrid
					projects={filtered}
					loading={loading}
					category={activeTab}
				/>

				{/* GitHub CTA */}
				<div className="mt-12 pt-8 border-t border-[#eee] dark:border-[#1a1a1a]">
					<a
						href="https://github.com/ariframaps"
						target="_blank"
						rel="noopener noreferrer"
						className="inline-flex items-center gap-2.5 font-poppins text-sm bg-black text-white dark:bg-[#0d0d0d] dark:text-[#ccc] dark:border dark:border-[#222] px-5 py-2.5 rounded-lg hover:bg-[#222] dark:hover:bg-[#161616] transition-colors duration-200">
						<svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
							<path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.385-1.335-1.755-1.335-1.755-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
						</svg>
						View all on GitHub
					</a>
				</div>
			</div>
		</section>
	);
};
